export default value => {
  return String(+value).charAt(0) == value ? `0${value}` : value
}
